<script setup lang="ts">
import AppIcon from '@ui/app-icon/AppIcon.vue'

import type { SelectItem } from '../types'

const props = withDefaults(defineProps<{
  item: SelectItem
  divider?: boolean
  selected?: boolean
}>(), {
  divider: false,
  selected: false,
})

const emit = defineEmits<{
  click: [item: SelectItem]
}>()
</script>

<template>
  <button
    class="app-select-item"
    :disabled="item.disabled"
    :class="{
      disabled: item.disabled,
      divider: props.divider,
    }"
    data-test-id="app-select-item"
    tabindex="-1"
    @click.stop="emit('click', item)"
  >
    <app-icon
      v-if="item.icon"
      class="app-select-item-left-icon"
      :name="item.icon"
    />
    <span class="app-select-item-text">
      {{ item.text }}
    </span>
    <app-icon
      v-show="props.selected"
      class="app-select-item-right-icon"
      name="Check"
    />
  </button>
</template>

<style lang="scss" scoped>
.app-select {
  &-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: 46px;
    padding: 0 16px;
    gap: 12px;
    border: none;
    border-bottom: 1px solid transparent;
    background-color: transparent;
    color: var(--g-neutral-1);
    font-family: 'General Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &-text {
      overflow: hidden;
      flex: 1 1 auto;
      min-width: 0;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &.divider {
      border-bottom: 1px solid var(--g-neutral-6);
    }

    &:hover, &:focus-visible {
      border-bottom: 1px solid transparent;
      border-radius: 10px;
      background-color: var(--g-neutral-7);
      outline: none;
    }

    &.disabled {
      color: var(--g-neutral-5);
      cursor: not-allowed;
    }

    &-right-icon {
      margin-left: auto;
      color: var(--a-mulberry);
    }
  }
}
</style>
